import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/VariableLayout.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/index.css");
